import type { ReactNode } from 'react';
import { useHelp } from '../lib/help';

// Gate inline grey explainer text on the global help toggle.
// Usage: wrap any <p> / span / fragment that should only show when help is ON.
export function HelpText({ children }: { children: ReactNode }) {
  const { helpOpen } = useHelp();
  return helpOpen ? <>{children}</> : null;
}
